// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__lvoqB","header":"MergedInvoice_header__2tj8H"};